import { render } from "./FaqPage.vue?vue&type=template&id=087c47cc&ts=true"
import script from "./FaqPage.vue?vue&type=script&lang=ts"
export * from "./FaqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__